import { render, staticRenderFns } from "./UbicacionMPYPT.vue?vue&type=template&id=38f57847&scoped=true&"
import script from "./UbicacionMPYPT.vue?vue&type=script&lang=js&"
export * from "./UbicacionMPYPT.vue?vue&type=script&lang=js&"
import style0 from "./UbicacionMPYPT.vue?vue&type=style&index=0&id=38f57847&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f57847",
  null
  
)

export default component.exports